import type { ReactNode } from "react";
import { Eyebrow, Lede } from "./primitives";

export function PageHero({
  eyebrow,
  children,
  lede,
  ctas,
}: {
  eyebrow: string;
  children: ReactNode;
  lede?: ReactNode;
  ctas?: ReactNode;
}) {
  return (
    <header className="border-b" style={{ borderColor: "rgba(0,47,167,0.12)" }}>
      <div className="wrap page-hero-wrap" style={{ padding: "88px 36px 64px" }}>
        <div className="max-w-4xl">
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1
            style={{
              fontFamily: '"IBM Plex Sans", "IBM Plex Sans Fallback", sans-serif',
              fontWeight: 200,
              fontSize: "clamp(36px, 5.6vw, 76px)",
              lineHeight: 1.05,
              letterSpacing: "-0.03em",
              margin: 0,
              color: "#002FA7",
            }}
          >
            {children}
          </h1>
          {lede ? (
            <div className="mt-6 max-w-2xl">
              <Lede>{lede}</Lede>
            </div>
          ) : null}
          {ctas ? <div className="mt-8 flex flex-wrap gap-2">{ctas}</div> : null}
        </div>
      </div>
    </header>
  );
}
